import SearchMembers from '@/components/search-members';
import { useSearchMembersState } from '@/components/search-members/useSearchMembersState';
import SelectedMembers from '../group-create/selected-members';
import SelectAllMembers from '../group-create/select-all-members';
import type { GroupAddMembersProps } from './interface';
import styles from './index.module.scss';

export default function GroupAddMembers({
  open,
  normalMemberList,
  onCancel,
  onActionOk,
}: GroupAddMembersProps) {
  const [loading, setLoading] = useState(false);

  const {
    selectedMembers,
    setSelectedMembers,
    membersList,
    updateMembersList,
    onSelect,
    onMemberDelete,
    onAllSelect,
    allSelectedMembers,
  } = useSearchMembersState();

  const handleInvite = useCallback(async () => {
    setLoading(true);
    await onActionOk?.(selectedMembers).catch((_) => '');
    setLoading(false);
  }, [selectedMembers, onActionOk]);

  useEffect(() => {
    if (open) {
      setSelectedMembers([]);
      updateMembersList({
        contacts: [],
        members: [],
        users: [],
      });
    }
  }, [open, setSelectedMembers, updateMembersList]);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      cancelText="Cancel"
      okText="Invite"
      title="Add Members"
      destroyOnHidden
      centered
      width={730}
      styles={{
        content: {
          padding: '24px 16px',
        },
      }}
      footer={
        <Flex justify="space-between" align="center">
          <SelectAllMembers
            selectedMembers={selectedMembers}
            allSelectedMembers={allSelectedMembers}
            onAllSelect={onAllSelect}
          />
          <Flex gap={16} align="center" justify="end">
            <Button onClick={onCancel}>Cancel</Button>
            <Button
              type="primary"
              loading={loading}
              onClick={handleInvite}
              disabled={!selectedMembers.length}
            >
              Invite
            </Button>
          </Flex>
        </Flex>
      }
    >
      <div className={styles.groupAddMembers}>
        <SearchMembers
          className={styles.searchMembers}
          searchBodyClassName={styles.searchBody}
          excludeMembers={normalMemberList}
          membersList={membersList}
          updateMembersList={updateMembersList}
          selectedList={selectedMembers}
          onSelect={onSelect}
        />
        <SelectedMembers
          selectedMembers={selectedMembers}
          onMemberDelete={onMemberDelete}
        />
      </div>
    </Modal>
  );
}
